import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asAvatarUpload" }
const _hoisted_2 = { class: "asAvatarUpload_avatar" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "asAvatarUpload_label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("img", {
          class: "asAvatarUpload_photo",
          src: _ctx.preview,
          alt: _ctx.$t('avatar')
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.btnText), 1),
      _createElementVNode("input", {
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileUpload && _ctx.fileUpload(...args))),
        class: "asAvatarUpload_input",
        type: "file",
        accept: "image/*"
      }, null, 32)
    ])
  ]))
}